
import { EnhancedUploadArea } from "../storage/EnhancedUploadArea";
import { useImageUpload } from "@/hooks/useImageUpload";

interface PartnerLogoUploadProps {
  currentUrl?: string;
  onUrlChange: (url: string) => void;
  disabled?: boolean;
}

export const PartnerLogoUpload = ({ 
  currentUrl, 
  onUrlChange, 
  disabled 
}: PartnerLogoUploadProps) => {
  const {
    uploading,
    currentUrl: displayUrl,
    uploadFile,
    clearImage,
    handleUrlInput,
  } = useImageUpload({
    bucketName: 'partner-logos',
    onPathChange: onUrlChange, // Store paths directly
    currentPath: currentUrl, // Treat currentUrl as a path
  });

  const handleFileUpload = (file: File) => {
    uploadFile(file);
  };

  const handleFileSelect = (bucketName: string, fileName: string) => {
    // Store just the path with leading slash
    onUrlChange(`/${fileName}`);
  };

  const handlePathChange = (path: string) => {
    handleUrlInput(path);
  };

  return (
    <div className="space-y-2">
      <EnhancedUploadArea
        label="Partner Logo"
        onFileUpload={handleFileUpload}
        onFileSelect={handleFileSelect}
        onPathChange={handlePathChange}
        uploading={uploading}
        acceptedTypes={['.jpg', '.jpeg', '.png', '.webp', '.gif']}
        allowedBuckets={['partner-logos']}
        showBrowseOption={true}
        showPathInput={true}
        currentPath={currentUrl || ''}
      />

      {/* Preview */}
      {(displayUrl || currentUrl) && (
        <div className="mt-2">
          <div className="relative inline-block">
            <img
              src={displayUrl || currentUrl}
              alt="Logo preview"
              className="h-20 w-32 object-contain rounded border bg-white p-2"
              onError={(e) => {
                console.error("Failed to load logo preview");
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
